import { z } from 'zod';
import { AccountIdSchema } from './accounts';
import { NumericalIdSchema } from './commonTypes';
import { GameIdSchema } from './games';
export var TrackableInfoSchema = z.object({
    account_id: AccountIdSchema
});
export var TrackableSchema = z.object({
    info: z.array(TrackableInfoSchema),
    game_product_id: NumericalIdSchema
});
/**
 * So I don't want to mess with the "trackable" schema that is being used by the CompanyStateStore
 * but in ServerActionCreators "addNewTrackableToGame" I am seeing properties that will likely be
 * part of that "TrackableSchema" and associated type.  As we migrate react components to TS, I
 * think we'll see that "TrackableSchema" is expected to have the properties that are defined below,
 * when that happens, we can move those properties to the "TrackableSchema" and remove them from
 * this type.  Once all the properties are moved, we can remove this type.
 */
export var ServerActionCreatorTrackableSchema = TrackableSchema.extend({
    name: z.string(),
    value_required: z.number().optional(),
    value_label: z.string().optional(),
    memo_required: z.number().optional(),
    trackable_mode: z.number(),
    game_id: GameIdSchema
});
